import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import { Heart } from "react-feather"
import { PAGE_URLS } from "../../constants/page-urls"
import { useLanguageStore } from "../../state-management/languageStore"

const containerVariants = {
    rest: {},
    hover: {
        transition: {
            staggerChildren: 0.2,
        },
    },
}

const cardVariants = {
    rest: { scale: 0.9, rotate: 5, x: 0, Y: 50 },
    hover: {
        scale: 1,
        rotate: 25,
        x: 100,
        y: 0,
        transition: {
            duration: 0.5,
            ease: "easeOut",
        },
    },
    repeating: {
        scale: [1, 1.02, 1],
        rotate: [10, 12, 10],
        x: [30, 32, 30],
        transition: {
            duration: 3,
            repeatDelay: 2,
            repeat: Infinity,
        },
    },
}

const heartVariants = {
    rest: { scale: 0.8, rotate: 0, y: 50, X: 0, opacity: 0 },
    hover: { scale: 1.02, rotate: 25, y: -2, x: 2, opacity: 1 },
    repeating: {
        scale: [1, 1.1, 1],
        rotate: [0, 15, 0],
        y: [0, -5, 0],
        x: [0, 5, 0],
        transition: {
            duration: 3,
            repeatDelay: 2,
            repeat: Infinity,
        },
    },
}
const heartVariants2 = {
    rest: { scale: 1, rotate: 0, y: 0, X: 0, opacity: 0 },
    hover: { scale: 1.02, rotate: -45, y: -2, x: 2, opacity: 1 },
    repeating: {
        scale: [1, 1.1, 1],
        rotate: [0, -5, 0],
        y: [0, -5, 0],
        x: [0, 10, 0],
        transition: {
            duration: 3,
            repeatDelay: 2,
            repeat: Infinity,
        },
    },
}
const MatchArticle = () => {
    const t = useLanguageStore((state) => state.translate)
    return (
        <div className="py-24">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-4 gap-y-16 max-w-6xl mx-auto px-4">
                <div className="flex flex-col justify-center gap-4 max-w-lg mx-auto">
                    <h1 className="text-3xl font-bold fg-color-1">
                        {t("home.match.title")}
                    </h1>
                    <p className="text-lg fg-color-2 -2 leading-8 max-w-[45ch]">
                        {t("home.match.body")}
                    </p>
                    <div className="flex w-full lg:w-auto pt-2">
                        <Link
                            to={PAGE_URLS.MATCH_GAME}
                            className="p-4 px-12 bg-gradient-to-br from-neutral-700 to-neutral-800 dark:from-neutral-100 dark:to-neutral-200 inset-0 text-white dark:text-black font-semibold text-center rounded-lg dark:hover:from-white dark:hover:to-white hover:from-black hover:to-black"
                        >
                            {t("home.match.cta")}
                        </Link>
                    </div>
                </div>
                <div className="pb-6">
                    <motion.div
                        variants={containerVariants}
                        initial="rest"
                        animate="rest"
                        whileInView={"hover"}
                        viewport={{ margin: "-30%", once: true }}
                        transition={{ delay: 0.5 }}
                        className="aspect-square max-w-sm relative mx-auto"
                    >
                        <div className="absolute top-4 left-4 w-full h-full ">
                            <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 152 145"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M97.8002 22.8C109.8 30.7 124.5 33 135.5 41.1C146.6 49.2 154.2 63.1 150 74.6C145.9 86.1 130.1 95.2 119.1 103.6C108.2 111.9 102.1 119.6 94.2002 124C86.4002 128.4 76.7002 129.5 64.2002 134.4C51.7002 139.3 36.3002 148 28.4002 143.7C20.5002 139.3 20.1002 121.8 15.8002 108.5C11.5002 95.2 3.40018 86.1 1.40018 75.8C-0.599822 65.5 3.40018 54.1 10.2002 45.2C17.0002 36.3 26.6002 30 36.6002 21C46.5002 11.9 56.8002 0.100006 66.6002 0.800006C76.4002 1.60001 85.7002 14.9 97.8002 22.8Z"
                                    fill="#34d399"
                                />
                            </svg>
                        </div>
                        <motion.div
                            variants={cardVariants}
                            className="relative h-full w-full"
                        >
                            <div className="absolute left-1/2 p-4 -translate-x-1/2 h-10/12 w-3/4 border dark:border-neutral-700 bg-white dark:bg-neutral-800 aspect-[3/4] rounded-xl space-y-4 divide-y divide-neutral-200 dark:divide-neutral-700 shadow-xl">
                                <div className="flex items-center gap-2 ">
                                    <div className="bg-color-3 size-12 rounded-lg"></div>
                                    <div className="bg-color-3 h-6 w-32 rounded-md"></div>
                                </div>
                                <div className="pt-4 flex items-center flex-wrap gap-2">
                                    <div className="bg-color-3 h-6 w-12 rounded-md"></div>
                                    <div className="bg-color-3 h-6 w-24 rounded-md"></div>
                                    <div className="bg-color-3 h-6 w-16 rounded-md"></div>
                                    <div className="bg-color-3 h-6 w-32 rounded-md"></div>
                                    <div className="bg-color-3 h-6 w-16 rounded-md"></div>
                                </div>
                                <div className="pt-4 flex items-center flex-wrap gap-2 ">
                                    <div className="bg-color-3 h-6 w-36 rounded-md"></div>
                                    <div className="bg-color-3 h-6 w-16 rounded-md"></div>
                                    <div className="bg-color-3 h-6 w-8 rounded-md"></div>
                                    <div className="bg-color-3 h-6 w-20 rounded-md"></div>
                                    <div className="bg-color-3 h-6 w-12 rounded-md"></div>
                                </div>
                            </div>
                            <motion.div
                                variants={heartVariants2}
                                transition={{
                                    delay: 0.2,
                                    duration: 0.5,
                                    ease: "easeOut",
                                }}
                                className="absolute -left-12 top-40"
                            >
                                <Heart className="size-32 text-pink-300 fill-pink-400 z-10  -rotate-12" />
                            </motion.div>
                            <motion.div
                                variants={heartVariants}
                                transition={{
                                    delay: 0.1,
                                    duration: 0.5,
                                    ease: "easeOut",
                                }}
                                className="absolute left-0 top-12"
                            >
                                <Heart className="size-20 text-pink-300 fill-pink-400 z-10  -rotate-45" />
                            </motion.div>
                            <motion.div
                                variants={heartVariants}
                                transition={{
                                    delay: 0,
                                    duration: 0.5,
                                    ease: "easeOut",
                                }}
                                className="absolute left-32 -top-8"
                            >
                                <Heart className="size-16 text-pink-200 fill-pink-300 z-10  -rotate-12" />
                            </motion.div>
                        </motion.div>
                    </motion.div>
                </div>
            </div>
        </div>
    )
}

export default MatchArticle
